import { createClient } from '@supabase/supabase-js';

// Project ID will be auto-injected during deployment.
const SUPABASE_URL = 'https://pylvsksuenkrzganhipy.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB5bHZza3N1ZW5rcnpnYW5oaXB5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTEyODgwNzAsImV4cCI6MjEwNjg2NDA3MH0.Wf4iELAT5MoGWgf1sFLariK6q0u6bNRMeuUc-6HPsus';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: true, autoRefreshToken: true }
});